import axiosInstance from "./axiosConfig";

export const addProductCategory = (category) => {
    const data = JSON.stringify({ "product_category_name": category })

    const config = {
        method: "POST",
        url: `/admin/add-ProductCategory`,
        headers: { 'Content-Type': 'application/json' },
        data: data,
    }

    const res = axiosInstance(config).then((res) => {
        return res.data
    }).catch((err) => {
        console.log("error in addProductCategory: ", err)
        return null;
    })

    return res;
}

export const getProductCategory = () => {

    const config = {
        method: "GET",
        url: `/admin/view-ProductCategories`,
    }

    const res = axiosInstance(config).then((res) => {
        return res.data
    }).catch((err) => {
        console.log("error in getProductCategory: ", err)
        return null;
    })

    return res;
}
export const deleteProductCategory = (id) => {
    let config = {
        method: 'delete',
        url: `/admin/delete-ProductCategory/${id}/`,
    };

    const data = axiosInstance.request(config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("error in delete productCategory: ", error);
            return null;
        });

    return data;
}

export const updateProductCategory = (id, category) => {
    let data = JSON.stringify({
        "product_category_name": category
    });

    let config = {
        method: 'patch',
        url: `/admin/update-ProductCategory/${id}/`,
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    const res = axiosInstance.request(config)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            console.log("error in update product category: ", error);
            return null;
        });

    return res;
}